export const MODERATION_BOT_DISPLAY_NAME = 'Schoolhouse Moderation Bot'

export const DEFAULT_ADMIN_MESSAGE_ACKNOWLEDGMENT_TEXT = 'I understand'
